<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 size pb-3">
                <v-tabs v-model="tab" align-with-title backgroundColor="white_highlight" active-class="active_tab">
                    <v-tabs-slider color="secondary"></v-tabs-slider>

                    <v-tab v-for="item in tab_items" :key="item" class="non_selected_tab">
                        {{ item }}
                    </v-tab>
                </v-tabs>
                <v-card-text class="px-0" v-if="tab != 4">
                    <v-row class="px-7 py-0 ml-1">
                        <v-col class="pt-2 py-0" cols="2">
                            <v-autocomplete class="mt-0" v-model="periodo" :items="periodos" :label="$t('dashboard.period')"></v-autocomplete> 
                        </v-col>
                        <v-col class="pt-2 py-0" cols="2">
                            <v-autocomplete class="mt-0" v-model="anio" :items="anios" :label="$t('dashboard.year')"></v-autocomplete> 
                        </v-col>
                        <v-col class="pt-2 py-0" cols="3" v-if="periodo == $t('dashboard.weekly')">
                            <v-autocomplete class="mt-0" v-model="currentWeek" :items="weeks" :label="$t('dashboard.week')"></v-autocomplete> 
                        </v-col>
                        <v-col class="pt-2 py-0" cols="3" v-if="periodo == $t('dashboard.monthly')">
                            <v-autocomplete class="mt-0" v-model="currentMonth" :items="monthsNames" :label="$t('dashboard.month')"></v-autocomplete> 
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-tabs-items v-model="tab">
                    <!-- Operation -->
                    <v-tab-item>
                        <d-operations 
                        :initial_date="initialDate" 
                        :final_date="finalDate"
                        :totalAppointmentsOptions="totalAppointmentsOptions"
                        :yearChartOptions="yearChartOptions"
                        :colors="colors"
                        :load="tab"
                        ></d-operations>
                    </v-tab-item>

                    <!-- Fulfillment -->
                    <v-tab-item>
                        <d-fulfillment 
                        :initial_date="initialDate" 
                        :final_date="finalDate"
                        :totalAppointmentsOptions="totalAppointmentsOptions"
                        :yearChartOptions="yearChartOptions"
                        :colors="colors"
                        :load="tab"
                        ></d-fulfillment>
                    </v-tab-item>

                    <!-- Supervision -->
                    <v-tab-item>
                        <d-supervision 
                        :initial_date="initialDate" 
                        :final_date="finalDate"
                        :yearChartOptions="sideChartOptions"
                        :colors="colors"
                        :load="tab"
                        ></d-supervision>
                    </v-tab-item>

                    <!-- Audits -->
                    <v-tab-item>
                        <d-audits 
                        :initial_date="initialDate" 
                        :final_date="finalDate"
                        :totalAppointmentsOptions="multipleCircleChartOptions"
                        :colors="colors"
                        :load="tab"
                        ></d-audits>
                    </v-tab-item>

                    <!-- Sales -->
                    <v-tab-item>
                        <d-sales 
                        :colors="colors"
                        :load="tab"
                        ></d-sales>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>    
        </v-container> 
    </div>
</template>

<script>

export default {
	components: {
        headers(){
            return [
                { text: this.$t('payments.client'), value: 'client_id' },
            ];
        }
    },
    data(){
        return {
            tab: 0,
            numberFormat: new Intl.NumberFormat('en-us', {minimumFractionDigits: 2, maximumFractionDigits: 2}),
            tab_items: [
                this.$t('dashboard.operation'), 
                this.$t('dashboard.fulfillment'), 
                this.$t('dashboard.supervision'), 
                this.$t('dashboard.audits'), 
                this.$t('dashboard.sales')
            ],
            colors:[
                "#D91136",
                "#932BD9",
                "#29A632",
                "#F2BB13",
                "#049DD9",
                "#F28B0C",
                "#FA23E1",
                "#0EEDE4",
                "#EAF205",
                "#BE56F5",
                "#03A688",
                "#0468BF"
            ],
            yearChartOptions: {
				scales: {
					xAxes: [{
						stacked: true,
                        padding: 0,
                        ticks: {
                            autoSkip: false,
                            minor: {
                                fontSize: 10
                            },
                            // maxRotation: 20,
                            // minRotation: 20
                        },
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        }
					}],
					yAxes: [{
						stacked: true,                
                        padding: 0,
                        ticks: {
                            beginAtZero: true,
                            minor: {
                                fontSize: 10
                            }
                        },
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        },
					},],
				},
				legend: { display: true, position: 'top'},
				maintainAspectRatio: false,
				cutoutPercentage: 0,
                responsive: false,
                lineTension: 1,
			},
            sideChartOptions: {
				scales: {
					xAxes: [{
						stacked: true,
                        padding: 0,
                        ticks: {
                            autoSkip: false,
                            minor: {
                                fontSize: 10
                            },
                            // maxRotation: 20,
                            // minRotation: 20
                        },
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        }
					}],
					yAxes: [{
						stacked: true,                
                        padding: 0,
                        ticks: {
                            beginAtZero: true,
                            minor: {
                                fontSize: 10
                            }
                        },
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        },
					},],
				},
				legend: { display: true, position: 'right'},
				maintainAspectRatio: false,
				cutoutPercentage: 0,
                responsive: true,
                lineTension: 1,
			},
            totalAppointmentsOptions: {
				maintainAspectRatio: true,
                responsive: true,
				cutoutPercentage: 75,
				legend: { display: true, position: 'right', labels: { fontSize: 10, padding: 4, margin: 30 } }
			},
            multipleCircleChartOptions: {
				maintainAspectRatio: true,
                responsive: true,
				cutoutPercentage: 75,
				legend: { display: true, position: 'bottom', labels: { fontSize: 10, padding: 4, margin: 30 } }
			},
            periodo: this.$t('dashboard.weekly'),
            periodos: [
                this.$t('dashboard.weekly'),
                this.$t('dashboard.monthly'),
                this.$t('dashboard.annual'),
            ],
            anio: new Date().getFullYear(),
            anios: this.$store.state.years_catalog,
            currentWeek: '',
            weeks: [],
            months: [
                { month: 1, es: 'Enero', en: 'January', days: 31},
                { month: 2, es: 'Febrero', en: 'February', days: 28},
                { month: 3, es: 'Marzo', en: 'March', days: 31},
                { month: 4, es: 'Abril', en: 'April',days: 30},
                { month: 5, es: 'Mayo', en: 'May', days: 31},
                { month: 6, es: 'Junio', en: 'June', days: 30},
                { month: 7, es: 'Julio', en: 'July', days: 31},
                { month: 8, es: 'Agosto', en: 'August', days: 31},
                { month: 9, es: 'Septiembre', en: 'September', days: 30},
                { month: 10, es: 'Octubre', en: 'October', days: 31},
                { month: 11, es: 'Noviembre', en: 'November', days: 30},
                { month: 12, es: 'Diciembre', en: 'December', days: 31},
            ],
            monthsNames: [],
            currentMonth : '',
            initialDate: '',
            finalDate: '',
        }
    },
    mounted(){

        this.weeks = this.getWeeks(this.year);
        this.getCurrentWeek();

        this.$store.state.module = "headers.dashboard";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        getWeeks() {
            let result = [];
            let start = new Date(this.anio, 0, 1);

            // Buscar primer lunes (semana natural)
            while (start.getDay() !== 1) { // 1 = lunes
                start.setDate(start.getDate() - 1);
            }

            while (start.getFullYear() <= this.anio) {
                const end = new Date(start);
                end.setDate(start.getDate() + 6);

                // Formatear fechas: 30/Diciembre - 05/Enero
                const rango = `${String(start.getDate()).padStart(2, "0")}/${this.months[start.getMonth()][this.$store.state.language]} - ${String(end.getDate()).padStart(2, "0")}/${this.months[end.getMonth()][this.$store.state.language]}`;
                this.weeks.push(rango);
                result.push({
                    start, end, rango
                });

                start = new Date(end);
                start.setDate(end.getDate() + 1);
            }

            return result;
        },
        startOfDay(date) {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate());
        },
        getCurrentWeek(year = new Date().getFullYear()) {
            const weeks = this.getWeeks(year);
            const today = this.startOfDay(new Date());

            // Buscar la semana donde hoy esté entre start y end
            const current = weeks.find(w => {
                const start = this.startOfDay(w.start);
                const end   = this.startOfDay(w.end);
                return today >= start && today <= end;
            });

            // Si no la encuentra (por estar en la última semana del año anterior), prueba con el año anterior
            if (!current && year > 1970) {
                const prevWeeks = this.getWeeks(year - 1);
                return prevWeeks.find(w => today >= w.start && today <= w.end);
            }

            this.currentWeek = current.rango;
        }
    },
    watch:{
        'periodo': function(){
            if(this.periodo == this.$t('dashboard.monthly')){
                if(this.$store.state.language == 'es') this.monthsNames = [
                    'Enero','Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
                ];
                else this.monthsNames = [
                    'January','February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
                ];
                const d = new Date();
                this.currentMonth = this.monthsNames[d.getMonth()];
                this.initialDate = this.anio + '-'+ (d.getMonth() + 1).toString().padStart(2, '0') + '-01';
                this.finalDate = this.anio + '-'+ (d.getMonth() + 1).toString().padStart(2, '0') + '-' + this.months[d.getMonth()].days;
                
            }
            else if(this.periodo == this.$t('dashboard.weekly')){
                const d = new Date();
                let dates = this.currentWeek.split('-');
                this.initialDate = this.anio + '-'+ (d.getMonth() + 1).toString().padStart(2, '0') + '-' + dates[0].split('/')[0].trim().padStart(2, '0');
                this.finalDate = this.anio + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + dates[1].split('/')[0].trim().padStart(2, '0');
                
            }
            else if(this.periodo == this.$t('dashboard.annual')){
                this.initialDate =  this.anio.toString() + '-01-01';
                this.finalDate = this.anio.toString() + '-12-31';
            }
        },
        'currentWeek': function(){
            if(this.$store.state.language == 'es') this.monthsNames = [
                'Enero','Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ];
            else this.monthsNames = [
                'January','February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
            ];

            let dates = this.currentWeek.split('-');
            let month1 = this.monthsNames.indexOf(dates[0].trim().split('/')[1].trim());
            let month2 = this.monthsNames.indexOf(dates[1].trim().split('/')[1].trim());
            
            if(month1 > month2) this.initialDate = this.anio - 1 + '-'+ (month1 + 1).toString().padStart(2, '0') + '-' + dates[0].trim().split('/')[0].trim().padStart(2, '0');
            else this.initialDate = this.anio + '-'+ (month1 + 1).toString().padStart(2, '0') + '-' + dates[0].trim().split('/')[0].trim().padStart(2, '0');

            this.finalDate = this.anio + '-' + (month2 + 1).toString().padStart(2, '0') + '-' + dates[1].trim().split('/')[0].trim().padStart(2, '0');
        },
        'currentMonth': function(){
            if(this.$store.state.language == 'es') this.monthsNames = [
                'Enero','Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ];

            else this.monthsNames = [
                'January','February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
            ];
            
            let month = this.monthsNames.indexOf(this.currentMonth);
            this.initialDate = this.anio + '-'+ (month + 1).toString().padStart(2, '0') + '-01';
            this.finalDate = this.anio + '-'+ (month + 1).toString().padStart(2, '0') + '-' + this.months[month].days;
        },
        'anio': function(){
            if(this.periodo == this.$t('dashboard.weekly')){
                if(this.$store.state.language == 'es') this.monthsNames = [
                    'Enero','Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
                ];
                else this.monthsNames = [
                    'January','February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
                ];

                let dates = this.currentWeek.split('-');
                let month1 = this.monthsNames.indexOf(dates[0].split('/')[1].trim());
                let month2 = this.monthsNames.indexOf(dates[1].split('/')[1].trim());
                this.initialDate = this.anio + '-'+ (month1 + 1).toString().padStart(2, '0') + '-' + dates[0].split('/')[0].trim().padStart(2, '0');
                this.finalDate = this.anio + '-' + (month2 + 1).toString().padStart(2, '0') + '-' + dates[1].split('/')[0].trim().padStart(2, '0');
            }
            else if(this.periodo == this.$t('dashboard.monthly')){
                if(this.$store.state.language == 'es') this.monthsNames = [
                    'Enero','Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
                ];

                else this.monthsNames = [
                    'January','February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
                ];
                
                let month = this.monthsNames.indexOf(this.currentMonth);
                this.initialDate = this.anio + '-'+ (month + 1).toString().padStart(2, '0') + '-01';
                this.finalDate = this.anio + '-'+ (month + 1).toString().padStart(2, '0') + '-' + this.months[month].days;
            }
            else if(this.periodo == this.$t('dashboard.annual')){
                this.finalDate = this.anio.toString() + '-12-31';
                this.initialDate =  this.anio.toString() + '-01-01';
            }
        }
    }
}
</script>

<style>

</style>
